import React, { useState } from "react";
import { useElevenLabsAction, useElevenLabsAgentOptions } from "../../hooks/useCallAction";
import ElevenLabsUI from "./ElevenLabsUI";
import { useRouteConfigModals } from "../contexts/RouteConfigModalsContext";

/**
 * ElevenLabs component - can be used for root or off-hours contexts
 * @param {string} context - 'root' | 'offHours' (defaults to 'root')
 */
const ElevenLabs = ({
  setOpenConfigureSlotModal,
  route,
  setRoute,
  context = "root",
  hasValidationError = false,
}) => {
  const routeModals = useRouteConfigModals();
  const [localChannels] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.channels?.L || []
  );
  const channels = routeModals?.channels ?? localChannels;
  const agentOptions = useElevenLabsAgentOptions(channels);
  const hasElevenLabsAgents = agentOptions.length > 0;

  const elevenLabsLogic = useElevenLabsAction(context, route, setRoute);

  return (
    <ElevenLabsUI
      {...elevenLabsLogic}
      setOpenConfigureSlotModal={setOpenConfigureSlotModal}
      hasValidationError={hasValidationError}
      agentOptions={agentOptions}
      hasElevenLabsAgents={hasElevenLabsAgents}
    />
  );
};

export default ElevenLabs;
